import { render } from "./pos-profile.vue?vue&type=template&id=af87faae"
import script from "./pos-profile.vue?vue&type=script&lang=js"
export * from "./pos-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__